/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Pricing page components
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  return (
    <SoftBox mt={16}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={6}>
          <SoftTypography pb={4} variant="h2" align="center" fontWeight="bold" gutterBottom>
            Frequently Asked Questions
          </SoftTypography>
          <SoftBox mb={2}>
            {/*<SoftTypography variant="body2" align="center" color="text">
              A lot of people don&apos;t appreciate the moment until it’s passed. I&apos;m not
              trying my hardest, and I&apos;m not trying to do
  </SoftTypography>*/}
          </SoftBox>
        </Grid>
        <Grid item xs={12} md={10}>
          <FaqCollapse
            title="How does your pricing compare to competitors?"
            open={collapse === 1}
            onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
          >
            Cost-Effectiveness and Value: Optimind-AI stands out not just for our affordability but also for our unparalleled value. As the leading dictation and summarization software for healthcare providers, we offer the most features, highest accuracies, and exceptional customizability—all at a price point that is significantly lower than our competitors. 
            With Optimind-AI, you receive more recording hours, more summarizations, and access to state-of-the-art AI models, all wrapped in the best-designed interface in the market. Our commitment to safety, customization, and innovation makes us not just cheaper, but the most cost-effective solution available.
            And for a little extra insight: feel free to take all the free trials of all competitors you can handle. We’re confident that, like a fine wine compared to grape juice, you’ll see (and taste) the difference with Optimind-AI. Cheers to making the informed choice!
          </FaqCollapse>
          <FaqCollapse
            title="How am I billed?"
            open={collapse === 2}
            onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
          >
            Billing Cycle: Our billing process is straightforward and transparent. 
            You are billed on a monthly basis, every 30 days, ensuring you have continuous access to our services without interruption.
          </FaqCollapse>
          <FaqCollapse
            title="On which devices can I use this service?"
            open={collapse === 3}
            onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
          >
            Device Compatibility: Optimind-AI is designed for universal access. You can use our platform on any device, provided you have an internet connection. 
            Whether on-the-go with your mobile device or at work on your desktop, Optimind-AI is right there with you.
          </FaqCollapse>
          <FaqCollapse
            title="Can I switch packages after purchasing a subscription?"
            open={collapse === 4}
            onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
          >
            Flexible Subscription Management: Absolutely! Upon subscribing, you gain access to your personal customer portal. 
            This portal empowers you to view invoices, switch between packages, cancel, and make any other adjustments to your subscription. 
            Your control over your subscription is complete and immediate.
          </FaqCollapse>
          <FaqCollapse
            title="Is Optimind-AI HIPAA compliant?"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            Compliance and Security: Yes, Optimind-AI is fully HIPAA compliant. 
            We prioritize the security and privacy of your data, adhering strictly to healthcare industry standards to protect sensitive information.
          </FaqCollapse>
          <FaqCollapse
            title="Is there a significant learning curve to using Optimind-AI?"
            open={collapse === 6}
            onClick={() => (collapse === 6 ? setCollapse(false) : setCollapse(6))}
          >
            Learning Curve and Support: While the learning curve for Optimind-AI might be steeper compared to other providers, it&apos;s important to remember that this is because our platform enables you to do ten times more than what&apos;s possible with other services. 
            Yes, it&apos;s a bit more to get to grips with initially, but the effort required is minimal when you consider the vast capabilities at your fingertips. 
            Plus, we&apos;ve got you covered with a comprehensive suite of tutorials. Just 30 minutes of focused time with these resources, and you&apos;ll have everything you need to make the most of our platform. 
            And trust us, it&apos;s absolutely worth it for the power and flexibility you gain!
          </FaqCollapse>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Faq;
